/*
 * @Author: your name
 * @Date: 2021-06-22 15:19:45
 * @LastEditTime: 2021-06-27 15:58:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\views\Im\information.js
 */
export default {
    friends(){
      let friends = [
        {
          id: 1,
          imgurl: 'https://img2.woyaogexing.com/2021/05/27/a7631412e51b4f00822499dca641aa91!400x400.jpeg',
          tip: 2,
          name: '彭于晏',
          news: '在干嘛',
          time: '16:00',
          classification: 1
        },
        {
          id: 2,
          imgurl: '2.jpeg',
          tip: 5,
          name: '吴彦祖',
          news: '在吗',
          time: '10:20',
          classification: 2
        },
        {
          id: 3,
          imgurl: '3.jpeg',
          tip: 25,
          name: '范冰冰',
          news: '不理我?',
          time: '14:32',
          classification: 1
        },
        {
          id: 4,
          imgurl: 'heads.png',
          tip: 3,
          name: '林志玲',
          news: '下班吃个饭',
          time: '15:00',
          classification: 1
        },
        {
          id: 5,
          imgurl: '4.jpeg',
          tip: 7,
          name: '吴亦凡',
          news: '下班吃个饭?',
          time: '13:20',
          classification: 2
        },
        {
          id: 6,
          imgurl: '5.jpeg',
          tip: 0,
          name: '王思聪',
          news: '下班吃个饭?',
          time: '13:20',
          classification: 2
        },
      ];
      return friends
    },
    message() {
      let message = [
        {
          id: 'a',
          imgurl: 'https://img2.woyaogexing.com/2021/06/25/450a5e3dad2145d7914bfae064c58cd7!400x400.jpeg',
          message: {
            voice: 'a',
            times: 60,
          },
          types: 'TIMSoundElem', //内容类型(0文字 , 1 图片链接 , 2音频链接 , 3自定义消息)
          time: '12:50',
          tip: 10,
        },
        {
          id: 'b',
          imgurl: 'https://img2.woyaogexing.com/2021/06/25/54f993b603d24092b7a695b3a089849c!400x400.jpeg',
          message: {
            voice: 'a',
            times: 30,
          },
          types: 'TIMSoundElem', //内容类型(0文字 , 1 图片链接 , 2音频链接)
          time: '12:50',
          tip: 15,
        },
        {
          id: 'a',
          imgurl: 'https://img2.woyaogexing.com/2021/06/25/450a5e3dad2145d7914bfae064c58cd7!400x400.jpeg',
          message: '在吗',
          types: 'TIMTextElem', //内容类型(0文字 , 1 图片链接 , 2音频链接)
          time: '12:50',
          tip: 0,
        },
        {
          id: 'b',
          imgurl: 'https://img2.woyaogexing.com/2021/06/25/54f993b603d24092b7a695b3a089849c!400x400.jpeg',
          message: 'dog.jpeg',
          types: 'TIMImageElem',
          time: '12:50',
          tip: 1,
        },
        {
          id: 'a',
          imgurl: 'https://img2.woyaogexing.com/2021/06/25/450a5e3dad2145d7914bfae064c58cd7!400x400.jpeg',
          message: '头像不错',
          types: 'TIMTextElem',
          time: '12:50',
          tip: 2,
        },
        {
          id: 'a',
          imgurl: 'https://img2.woyaogexing.com/2021/06/25/450a5e3dad2145d7914bfae064c58cd7!400x400.jpeg',
          message: '在哪换的',
          types: 'TIMTextElem',
          time: '12:50',
          tip: 3,
        },
  
  
  
        {
          id: 'b',
          imgurl: 'https://img2.woyaogexing.com/2021/06/25/54f993b603d24092b7a695b3a089849c!400x400.jpeg',
          message: '百度找的',
          types: 'TIMTextElem',
          time: '12:50',
          tip: 5,
        },
        {
          id: 'a',
          imgurl: 'https://img2.woyaogexing.com/2021/06/25/54f993b603d24092b7a695b3a089849c!400x400.jpeg',
          message: 'heads.png',
          types: 'TIMImageElem',
          time: '12:50',
          tip: 6,
        },
        {
          id: 'b',
          imgurl: 'https://img2.woyaogexing.com/2021/06/25/54f993b603d24092b7a695b3a089849c!400x400.jpeg',
          message: {
            description:{
              productDescription: '大理+香格里拉双飞5日跟团游<云南全景，环飞旅游按时到达>',
              url: 'www.baidu.com',
              imageUrl: 'https://img2.woyaogexing.com/2021/06/08/fe96f309b64d4c178f0194fb228d4d6b!400x400.jpeg',
              shopCode: '',
              productCode: '',
              userCode: '',
              orgCode: '',
              price: '998',
              origin: '西安',
              destination: '大理',
              productSource: '',
              productShare: '',
  
              sendMessageVO: {
                from_Account: '',
                to_Account: '',
                msgBody: [{
                  msgType: '',
                  msgContent: {
                    data: ''
                  }
                }]
              },
            },
          },
          types: 'TIMCustomElem', //内容类型(0文字 , 1 图片链接 , 2音频链接 , 3自定义消息)
          time: '12:50',
          tip: 20,
        },
        {
          id: 'a',
          imgurl: 'https://img2.woyaogexing.com/2021/06/25/450a5e3dad2145d7914bfae064c58cd7!400x400.jpeg',
          message: {
            description:{
              productDescription: '大理+香格里拉双飞5日跟团游<云南全景，环飞旅游按时到达>',
              url: 'www.baidu.com',
              imageUrl: 'https://img2.woyaogexing.com/2021/06/10/ef8097ad79f54b97808aba5638fff9f7!400x400.jpeg',
              shopCode: '',
              productCode: '',
              userCode: '',
              orgCode: '',
              price: '1099',
              origin: '西安',
              destination: '大理',
              productSource: '',
              productShare: '',
  
              sendMessageVO: {
                from_Account: '',
                to_Account: '',
                msgBody: [{
                  msgType: '',
                  msgContent: {
                    data: ''
                  }
                }]
              },
            },
          },
          types: 'TIMCustomElem', //内容类型(0文字 , 1 图片链接 , 2音频链接 , 3自定义消息)
          time: '12:50',
          tip: 21,
        },
      ];
      return message
    },
  }


// WEBPACK FOOTER //
// ./src/TASMini/views/Im/information.js